import { string } from "prop-types";
import {
  GoalHistoryBlockShape,
  patientGoalHistoryRecordShape,
} from "../interfaces/classTypes";

let allGoalHistoryBlocks = [];
let goalTemplateArray = [];
export class GoalHistoryBlock {
  public goalId: number;
  public templateId: number;
  public name: string;
  public templateName: string;
  public achievementThresholdFormatted: string;
  public recordBlock: any;

  constructor(data: GoalHistoryBlockShape) {
    this.goalId = data.id;
    this.name = data.name;
    this.achievementThresholdFormatted = data.achievementThresholdFormatted;
    this.templateId = data.templateId;
    this.templateName = data.templateName;
    this.recordBlock = data.patientGoalHistories.map(
      (record) => new GoalHistoryRecord(record, this)
    );
    this.save();
  }

  save() {
    allGoalHistoryBlocks.push(this);
    if (!goalTemplateArray.find((i) => i == this.templateId)) {
      goalTemplateArray.push(this.templateId);
    }
  }

  formatted() {}

  static allGoalHistoryBlocks() {
    return allGoalHistoryBlocks;
  }

  static goalTemplateArray() {
    return goalTemplateArray;
  }

  static compiledSets() {
    return goalTemplateArray.map((id) => {
      var childBlocks = allGoalHistoryBlocks.filter(
        (block) => block.templateId == id
      );

      const childBlockSorter = (a, b) => {
        if (a.goalId < b.goalId) {
          return 1;
        }
        if (a.goalId > b.goalId) {
          return -1;
        }
        return 0;
      };

      var sortedChildBlocks = childBlocks.sort(childBlockSorter);

      var templateName = allGoalHistoryBlocks.find(
        (template) => template.templateId == id
      ).templateName;

      const recordBlockSorter = (a, b) => {
        if (a.occurrenceNumber < b.occurrenceNumber) {
          return 1;
        }
        if (a.occurrenceNumber > b.occurrenceNumber) {
          return -1;
        }
        return 0;
      };

      var formattedchildBlocks = sortedChildBlocks.map((block) => {
        var childBlock = [];
        var blockName = { name: block.name };
        childBlock.push(blockName);
        var sortedChildren = block.recordBlock.sort(recordBlockSorter);
        sortedChildren.forEach((child) => childBlock.push(child));
        return childBlock;
      });

      return { templateName: templateName, recordBlock: formattedchildBlocks };
    });
  }

  static clear() {
    allGoalHistoryBlocks = [];
  }
}

export class GoalHistoryRecord {
  public isActive: boolean;
  public achievementStatusFormatted: string;
  public completionColor: string;
  public completionPercentage: string;
  public occurrenceNumber: number;
  public patientGoalId: number;
  public timeFrame: string;
  public goal: any;

  constructor(data: patientGoalHistoryRecordShape, goal) {
    this.achievementStatusFormatted = data.achievementStatusFormatted;
    this.completionColor = data.completionColor;
    this.completionPercentage = data.completionPercentageFormatted;
    this.isActive = data.isActive;
    this.occurrenceNumber = data.occurrenceNumber;
    this.patientGoalId = data.patientGoalId;
    this.timeFrame = data.timeframe;
    this.goal = goal;
  }
}
